module.exports = __webpack_public_path__ + "img/CEOVision.d206a225.jpg";